import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import { getAllStaticCategoriesCollection } from 'app/src/msw/companyagreement/initialSeed/categories'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import type { Category } from 'app/src/services/welfareportal/companyagreement-api'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getCategories = http.get<object, DefaultBodyType, companyagreementApi.CategoryPaginated>(
  apiBaseUrl + '/categories',
  async ({ request }) => {
    // set of request parameters
    const url = new URL(request.url)
    const limit: number = Number.parseInt(url.searchParams.get('pagingLimit') ?? '10')
    const offset: number = Number.parseInt(url.searchParams.get('pagingOffset') ?? '0')
    const serviceCategory = url.searchParams.get('serviceCategory') ?? ''
    const parentCategoryId = url.searchParams.get('parentCategoryId') ?? ''

    console.log('Received request for getCategories with params:', {
      limit,
      offset,
      serviceCategory,
      parentCategoryId,
    })

    let categoryCollection: (Category & { serviceCategory: string })[] = await getAllStaticCategoriesCollection()

    // empty response
    const emptyResponse: companyagreementApi.CategoryPaginated = { paging: { limit, offset, total: 0 }, items: [] }

    /**
     * Converts an array of categories into a paginated response.
     * @param categories The array of categories to paginate.
     * @returns A paginated response containing the categories.
     */
    const convertToPaginatedResponse = (categories: companyagreementApi.Category[]): companyagreementApi.CategoryPaginated => ({
      paging: { limit, offset, total: categories.length },
      items: categories.slice(offset, offset + limit),
    })

    // if serviceCategory is provided, add it to the where clause
    if (serviceCategory) {
      categoryCollection = categoryCollection.filter(
        (category: Category & { serviceCategory: string }) => category.serviceCategory === serviceCategory,
      )
    }

    // if parentCategoryId is provided, add it to the where clause
    if (parentCategoryId) {
      categoryCollection = categoryCollection.filter(
        (category: Category & { serviceCategory: string }) => category.parentCategoryId === parentCategoryId,
      )
    }

    // if no categories are found, return an empty response
    if (!categoryCollection.length) {
      return HttpResponse.json(emptyResponse)
    } else {
      const response = convertToPaginatedResponse(categoryCollection)
      return HttpResponse.json(response)
    }
  },
)
